import React from 'react';
import { entityRefPath } from 'src/app/chat/entityRefs';
import { AnchorLink } from 'src/design/molecules/AnchorLink';

export interface IEntityRefLinkProps {
  href: string | null | undefined;
  onRefClick?: () => void;
  children: React.ReactNode;
}

const isPlainPrimaryClick = (event: React.MouseEvent): boolean =>
  event.button === 0 &&
  !event.metaKey &&
  !event.ctrlKey &&
  !event.shiftKey &&
  !event.altKey;

/** @registry Renders a chat `ref:` entity link as an in-app router link that calls `onRefClick` on a plain left click (not a new-tab click), or only its children when the href is missing or does not map to a route. */
export const EntityRefLink: React.FC<IEntityRefLinkProps> = ({
  href,
  onRefClick,
  children,
}) => {
  const path = href ? entityRefPath(href) : null;
  if (path === null) return <>{children}</>;
  return (
    <AnchorLink
      to={path}
      onClick={(event) => {
        if (isPlainPrimaryClick(event)) onRefClick?.();
      }}
    >
      {children}
    </AnchorLink>
  );
};
